"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPropertyTypes = exports.listToObject = exports.addRefIdToProperties = exports.normalizePropertiesInput = exports.OldPropertiesSchema = exports.PropertyDataSchema = exports.AddPropertyWithoutRefSchema = exports.PropertySchema = exports.DataScheme = exports.AddressSchema = exports.ValidatedPropertyHandles = exports.PropertyDataType = void 0;
const zod_1 = __importDefault(require("zod"));
const __1 = require("..");
var PropertyDataType;
(function (PropertyDataType) {
    PropertyDataType["checkbox"] = "checkbox";
    PropertyDataType["datePicker"] = "date-picker";
    PropertyDataType["dropdown"] = "dropdown";
    PropertyDataType["singleLineText"] = "single-line-text";
    PropertyDataType["multiLineText"] = "multi-line-text";
    PropertyDataType["number"] = "number";
    PropertyDataType["file"] = "file";
    PropertyDataType["address"] = "address";
    PropertyDataType["money"] = "money";
})(PropertyDataType || (exports.PropertyDataType = PropertyDataType = {}));
var ValidatedPropertyHandles;
(function (ValidatedPropertyHandles) {
    ValidatedPropertyHandles["email"] = "email";
    ValidatedPropertyHandles["name"] = "name";
    ValidatedPropertyHandles["phone"] = "phone";
})(ValidatedPropertyHandles || (exports.ValidatedPropertyHandles = ValidatedPropertyHandles = {}));
exports.AddressSchema = zod_1.default.object({
    address: zod_1.default.string(),
    coAddress: zod_1.default.string().nullish(),
    zipcode: zod_1.default.string(),
    city: zod_1.default.string(),
    country: zod_1.default.string().nullish(),
    door: zod_1.default.string().nullish(),
    floor: zod_1.default.string().nullish(),
    houseNoFrom: zod_1.default.number().nullish(),
    level: zod_1.default.string().nullish(),
    formatted: zod_1.default.string().nullish(),
    addressTwo: zod_1.default.string().nullish(),
    street: zod_1.default.string().nullish(),
    dawsId: zod_1.default.string().nullish(),
    text: zod_1.default.string().nullish(),
    longitiude: zod_1.default.number().nullish(),
    latitude: zod_1.default.number().nullish(),
});
exports.DataScheme = zod_1.default.union([
    zod_1.default.object({
        type: zod_1.default.literal(PropertyDataType.checkbox),
        data: zod_1.default.boolean().nullish(),
    }),
    zod_1.default.object({
        type: zod_1.default.union([
            zod_1.default.literal(PropertyDataType.singleLineText),
            zod_1.default.literal(PropertyDataType.multiLineText),
            zod_1.default.literal(PropertyDataType.dropdown),
        ]),
        data: zod_1.default.string().nullish(),
    }),
    zod_1.default.object({
        type: zod_1.default.literal(PropertyDataType.number),
        data: zod_1.default.number().nullish(),
    }),
    zod_1.default.object({
        type: zod_1.default.literal(PropertyDataType.datePicker),
        data: zod_1.default.string().nullish(),
    }),
    zod_1.default.object({
        type: zod_1.default.literal(PropertyDataType.address),
        data: exports.AddressSchema,
    }),
    zod_1.default.object({
        type: zod_1.default.literal(PropertyDataType.money),
        data: zod_1.default
            .object({
            amount: zod_1.default.number().int(),
            currency: zod_1.default.string(),
        })
            .nullish(),
    }),
    zod_1.default.object({
        type: zod_1.default.literal(PropertyDataType.file),
        data: zod_1.default
            .object({
            fileId: zod_1.default.string(),
            contentType: zod_1.default.string(),
            fileName: zod_1.default.string(),
        })
            .nullish(),
    }),
]);
exports.PropertySchema = zod_1.default
    .object({
    ref: zod_1.default.union([
        zod_1.default.literal(__1.Entity.Case),
        zod_1.default.literal(__1.Entity.CaseVoucher),
        zod_1.default.literal(__1.Entity.Creditor),
        zod_1.default.literal(__1.Entity.Collector),
    ]),
    refId: zod_1.default.string().uuid(),
    handle: zod_1.default.string(),
})
    .and(exports.DataScheme);
exports.AddPropertyWithoutRefSchema = zod_1.default
    .object({
    handle: zod_1.default.string(),
})
    .and(exports.DataScheme);
exports.PropertyDataSchema = zod_1.default
    .union([
    zod_1.default.string(),
    zod_1.default.number(),
    zod_1.default.boolean(),
    zod_1.default.object({
        amount: zod_1.default.number(),
        currency: zod_1.default.nativeEnum(__1.Currency),
    }),
    zod_1.default.object({
        fileId: zod_1.default.string(),
        contentType: zod_1.default.string(),
        fileName: zod_1.default.string(),
    }),
    exports.AddressSchema,
])
    .nullable();
exports.OldPropertiesSchema = zod_1.default.object({
    handle: zod_1.default.string(),
    data: zod_1.default.union([
        zod_1.default.object({
            text: zod_1.default.string(),
        }),
        zod_1.default.object({
            value: zod_1.default.string(),
        }),
        zod_1.default.object({
            date: zod_1.default.string(),
        }),
        zod_1.default.object({
            amount: zod_1.default.number(),
            currency: zod_1.default.nativeEnum(__1.Currency),
        }),
        zod_1.default.object({
            checked: zod_1.default.boolean(),
        }),
    ]),
});
const normalizePropertiesInput = (properties) => {
    if (Array.isArray(properties)) {
        return properties.reduce((acc, property) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (!property) {
                return acc;
            }
            if (typeof ((_a = property.data) === null || _a === void 0 ? void 0 : _a.text) !== 'undefined') {
                acc[property.handle] = (_b = property.data) === null || _b === void 0 ? void 0 : _b.text;
            }
            else if (typeof ((_c = property.data) === null || _c === void 0 ? void 0 : _c.number) !== 'undefined') {
                acc[property.handle] = (_d = property.data) === null || _d === void 0 ? void 0 : _d.number;
            }
            else if (typeof ((_e = property.data) === null || _e === void 0 ? void 0 : _e.value) !== 'undefined') {
                acc[property.handle] = (_f = property.data) === null || _f === void 0 ? void 0 : _f.value;
            }
            else if (typeof ((_g = property.data) === null || _g === void 0 ? void 0 : _g.date) !== 'undefined') {
                acc[property.handle] = (_h = property.data) === null || _h === void 0 ? void 0 : _h.date;
            }
            else if (typeof ((_j = property.data) === null || _j === void 0 ? void 0 : _j.checked) !== 'undefined') {
                acc[property.handle] = (_k = property.data) === null || _k === void 0 ? void 0 : _k.checked;
            }
            else {
                acc[property.handle] = property.data;
            }
            return acc;
        }, {});
    }
    else {
        return properties;
    }
};
exports.normalizePropertiesInput = normalizePropertiesInput;
const addRefIdToProperties = (properties, ref, refId) => properties.map((property) => (Object.assign(Object.assign({}, property), { refId: refId, ref: ref })));
exports.addRefIdToProperties = addRefIdToProperties;
const listToObject = (properties) => {
    return properties.reduce((acc, property) => {
        acc[property.handle] = property.data;
        return acc;
    }, {});
};
exports.listToObject = listToObject;
const filterPropertyTypes = (propertyTypes, ref, scope, scopeId) => propertyTypes.filter((type) => {
    if (type.ref !== ref) {
        return false;
    }
    if (!type.scopeId) {
        return true;
    }
    if (scopeId &&
        scope &&
        type.scopeId &&
        type.scopeId === scopeId &&
        type.scope === scope) {
        return true;
    }
    return false;
});
exports.filterPropertyTypes = filterPropertyTypes;
//# sourceMappingURL=index.js.map